import React, { useState } from "react";
import "./PhotographerTable.css";
import VerifyPhotographerModal from "./VerifyPhotographerModal/VerifyPhotographerModal";
import PhotographerRatingModal from "./PhotographerRatingModal/PhotographerRatingModal";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiTrash } from "react-icons/fi";
import EditPhotographerModal from "./EditPhotographerModal/EditPhotographerModal";
import DeletePhotographerModal from "./DeletePhotographerModal/DeletePhotographerModal";

const PhotographerTable = ({ data = [], showVerify, page, limit, refreshData }) => {
  console.log("UNVERIFIED DATA")
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);


  const [selectedPhotographer, setSelectedPhotographer] = useState(null);
  const navigate = useNavigate();

  const openVerifyModal = (photographer) => {
    setSelectedPhotographer(photographer);
    setIsModalOpen(true);
  };

  const openRatingsModal = (photographer) => {
    setSelectedPhotographer(photographer);
    setIsRatingModalOpen(true);
  };


  const handleProfile = (photographer) => {
    navigate(`/photographer-profile/${photographer?._id}`, { state: { photographer } });
  };


  const handleEdit = (photographer) => {
    setSelectedPhotographer(photographer);
    setIsEditOpen(true);
  };


  const handleDelete = (photographer) => {
    setSelectedPhotographer(photographer);
    setIsDeleteOpen(true);
  };

  return (
    <>
      <div className="photographer-table-wrapper">
        <table className="photographer-table">
          <thead>
            <tr>
              <th className="td-sr">Sr.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Experience (YOE)</th>
              <th>City</th>
              <th>Type</th>
              <th>Sign-Up Date</th>
              <th>Profile</th>
              {showVerify && <th>Verify</th>}
              <th>Actions</th>
              {!showVerify &&<th>Ratings</th>}

            </tr>
          </thead>

          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id || index}>
                  <td className="td-sr">
                    {(page - 1) * limit + index + 1}
                  </td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.experience}</td>
                  <td>{item.city}</td>
                  <td>{item.photographerType || "-"}</td>
                  <td>{item.signUpDate}</td>

                  <td>
                    <span
                      className="profile-icon"
                      onClick={() => handleProfile(item)}
                    >
                      👤
                    </span>
                  </td>

                  {showVerify && (
                    <td>
                      <button
                        className="btn-verify"
                        onClick={() => openVerifyModal(item)}
                      >
                        ✔ Verify 
                      </button>
                    </td>
                  )}
                  
                

                  <td className="action-col">
                    <button
                      className="chat-btn edit-btn"
                      onClick={() => handleEdit(item)}
                      title="Edit Photographer"
                    >
                      <FiEdit size={16} />
                    </button>

                    <button
                      className="chat-btn delete-btn"
                      onClick={() => handleDelete(item)}
                      title="Delete Photographer"
                    >
                      <FiTrash size={16} />
                    </button>
                  </td>

                    {!showVerify && (
                    <td>
                      <button
                        className="btn-verify"
                        onClick={() => openRatingsModal(item)}
                      >
                        ★ Ratings
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={showVerify ? 11 : 10} style={{ padding: "20px" }}>
                  No photographer available
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      {/* Modal */}
      <VerifyPhotographerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        photographer={selectedPhotographer}
        onVerified={refreshData}
      />

      <EditPhotographerModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        photographer={selectedPhotographer}
        onEdit={refreshData}
      />

      <DeletePhotographerModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        photographer={selectedPhotographer}
        onDeleted={refreshData}
      />

      <PhotographerRatingModal
        isOpen={isRatingModalOpen}
        onClose={() => setIsRatingModalOpen(false)}
        photographer={selectedPhotographer}
        onEdit={refreshData}
      />

    </>
  );
};

export default PhotographerTable;
